import { useContext } from "react";
import { Box, Typography } from "@mui/material";

import { AbilityContext } from "../../permission/Can";
import { Actions, Subjects } from "../../permission/constants";

import JoinPremiumButton from "../Buttons/JoinPremiumButton/JoinPremiumButton";
import PremiumBadgeIcon from "../../img/icons/vip.png";

const SettingsSidebar = () => {
  const ability = useContext(AbilityContext);

  return (
    <Box
      sx={{
        marginTop: { xs: "1rem", sm: "0rem" },
      }}
    >
      {ability.can(Actions.VIEW, Subjects.UPGRADE_MEMBERSHIP) && (
        <Box
          sx={{
            padding: "1rem 1rem",
            borderRadius: "10px",
            backgroundColor: "#fff",
          }}
        >
          <Box marginBottom={"0.5rem"}>
            <img loading="lazy" width="60" src={PremiumBadgeIcon} alt="" />
          </Box>
          <Box marginBottom={"1rem"}>
            <Typography
              variant="body1"
              sx={{
                color: "#3c3c40  !important",
                fontWeight: 600,
                fontSize: "1rem !important",
                lineHeight: "1.5rem",
                marginBottom: "0.5rem",
              }}
            >
              Take your collection to the next level and make an impact in the
              collector's community!
            </Typography>
          </Box>
          <Box>
            <JoinPremiumButton text="Upgrade" />
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default SettingsSidebar;
